import {
    GET_GIFTCARD_PROVIDERS,
    GET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS,
    RESET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS
} from '../../../../actions/types';

const INITIAL_STATE = {
    giftCardProviders: [],
    restaurantGiftCardProvider: {}

};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_GIFTCARD_PROVIDERS:
            return {...state, giftCardProviders: action.payload};
        case GET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS:
            return {...state, restaurantGiftCardProvider: action.payload};
        case RESET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS:
            return {...state, restaurantGiftCardProvider: null};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/GiftCardProviderReducer.js